import { CalendarGetResponse } from "@kase/my-marathon-communication";
import { TimeValidationError } from "~/core/errors";
import { TimeValidationErrorRecord } from "~/core/errors/interfaces";
import { store } from "~/core/store";
import { dateToApi } from "~/utils";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { Calendar, SetCalendarStatusRequest } from "./interfaces";

const getKey = (year: number, month: number) => `${year}-${month}`;

export const makeCalendar = ({ connection, company }: ApiSliceParams) => {
    const {
        items: calendars,
        loading,
        listen,
    } = createListController<
        CalendarGetResponse,
        Calendar,
        { year: number; month: number }
    >({
        connection,
        list: (con, { year, month }) =>
            con.time.calendar.items({ company: company.value, year, month }),
        name: "calendar",
        getKey: ({ year, month }) => getKey(year, month),
    });

    const setCalendarStatus = async ({
        date,
        status,
        id,
    }: SetCalendarStatusRequest) => {
        const con = connection.value;
        const apiDate = dateToApi(date);

        try {
            return await con.time.calendar.set({
                company: company.value,
                date: apiDate,
                status,
                id,
            });
        } catch (err: unknown) {
            const ids = store.api.time.report.reports
                .peek()
                .filter((i) => i.date === apiDate)
                .map((i) => i._id);
            const errors: TimeValidationErrorRecord[] = [];

            if (ids.length > 0) {
                for await (const validation of con.time.validate({
                    company: company.value,
                    id: ids,
                })) {
                    if (validation.errors && validation.errors.length > 0) {
                        errors.push({
                            id: validation.id.toString(),
                            errors: validation.errors,
                        });
                    }
                }
            }

            if (errors.length > 0) {
                throw new TimeValidationError(
                    "You have invalid reports for this date. Fix them before changing the status",
                    errors,
                );
            } else {
                throw err;
            }
        }
    };

    return { calendars, loading, listen, setCalendarStatus };
};
